module.exports = __webpack_public_path__ + "static/media/success.6961e468.svg";